<template>
  <AppView
    padd-bottom
  >

    <template v-slot:top-app-view>
      <transition name="fade" mode="out-in" appear>
        <!-- // * not using CompanyHeader because of companyLogo data -->
        <TopNav
          type="back"
          :prev-route="{ name: (isSuperAdmin ? 'viewCompany' : 'myLicense'), params: { id: $route.params.id } }"
          :title="company.company || 'fetching company...'"
          :title-class="[
            'tw-ml-8',
            { 'opacity-78 font-title tw-text-xl tw-tracking-wider tw-leading-6': !loadingCompany },
            { 'opacity-31 tw-italic tw-lowercase': loadingCompany },
          ]"
        >
          <template v-slot:title-left v-if="!loadingCompany">
            <UserPhoto
              :photo="company.logo"
              :user-name="{
                name: company.company,
              }"
              logo
              photo-size="tw-h-12 tw-w-12"
              :class="[
                'tw-mr-6 tw-my-1 tw-rounded-10--force --force-children tw-bg-app-white-87',
                { 'tw-shadow-app-sm': !(company.logo || '').length }
              ]"
            />
          </template>
        </TopNav>
      </transition>
    </template>

    <portal to="modal-body">
      <transition name="new" mode="out-in" appear>
        <div>
          <h3
            class="tw-text-center tw-text-app-deep-blue tw-text-xl tw-leading-6 font-title tw-uppercase"
          >
            Add users to program
          </h3>
          <EditCompanyProgramUsers
            class="tw-mx-auto tw-mt-10"
            v-if="!loadingCompanyProgram"
            :company-program="activeCompanyProgram"
            @saved="programUsersUpdated"
          />
        </div>
      </transition>
    </portal>

    <transition name="fade" mode="out-in" appear>

      <div v-if="errorCompany || errorCompanyProgram" class="tw-mt-12" key="errmsg">
        <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorCompany || errorCompanyProgram"></p>
      </div>

      <div v-else-if="loadingCompany || loadingCompanyProgram" class="tw-mt-12" key="lodng">
        <p class="tw-py-12 tw-text-base tw-text-center">Loading...</p>
      </div>

      <div v-else key="bdy">
        <transition name="fade" mode="out-in" appear>

          <div class="app-view-grid px-body">
            <div class="app-view-grid__col-74">
              <div class="tw-flex tw-items-center">
                <UserPhoto
                  :photo="activeCompanyProgram.logo"
                  :user-name="{
                    name: activeCompanyProgram.name,
                  }"
                  logo
                  photo-size="tw-h-10 tw-w-10"
                  :class="[
                    'tw-rounded-10--force --force-children tw-bg-app-white-87 tw-mx-2',
                    { 'tw-shadow-app-sm': !(activeCompanyProgram.logo || '').length }
                  ]"
                />

                <p class="tw-font-bold">
                  {{ activeCompanyProgram.name }} Mentorship Program
                </p>
              </div>

              <template>
                <div class="tw-flex tw-items-center tw-pt-10 tw-pb-3">
                  <h3 class="font-title tw-text-xl tw-tracking-wider">
                    Program Users
                  </h3>

                  <div class="tw-ml-auto">
                    <BaseButton text="Add Users" @click="promptAddUsersToProgram()" />
                    <BaseButton class="tw-ml-2 tw-border-app-black-11" :text="reportBtnText" :disabled="disabledReportBtn || loadingProgramUsers" @click="generateReport()" />
                  </div>
                </div>
                <div class="tw-border-t tw-border-app-black-11 tw-mb-6"></div>


              </template>
            </div>
          </div>

        </transition>

        <transition name="fade" mode="out-in" appear>

          <div class="app-view-grid px-body">
            <div class="app-view-grid__col-74">
              <!-- LIST OF USERS -->
              <div v-if="errorProgramUsers" class="tw-mt-12">
                <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorAccounts"></p>
              </div>

              <ContentLoadingFullWidth
                v-else-if="loadingProgramUsers"
                class="tw-py-16 -tw-max-w-list tw-mx-auto"
                :list-length="4"
              />

              <template v-else>

                <div v-if="programUsers.length === 0" class="tw-mt-4">
                  <!-- Goodies -->
                  <p class="tw-py-16 tw-text-base tw-text-center opacity-54">There are 0 Users in the program</p>
                </div>

                <AccountsList
                  v-else
                  searchable
                  class="tw-max-w-list tw-mx-auto tw-mt-4"
                  :list="programUsers"
                >
                  <template v-slot:account-actions="{ item: user, index }">
                    <div :key="`user-${index}`" class="tw-inline-flex tw-items-center">
                      <BaseButton
                        v-if="Number(user.programStatus) === 0"
                        text="Activate"
                        class="tw-mx-2"
                        :disabled="isActivatingUser"
                        @click="activateUserToProgram(user)"
                      />
                      <BaseButton
                        v-if="Number(user.programStatus) === 1"
                        text="Deactivate"
                        class="tw-bg-yellow-500 tw-text-yellow-900 tw-border-0"
                        :disabled="isActivatingUser"
                        @click="deactivateUserToProgram(user)"
                      />

                      <!-- <BaseButton
                        text="Remove"
                        class="tw-bg-red-500 tw-text-white tw-border-0 opacity-54 hover:tw-opacity-100"
                        @click="removeUserFromProgram(user)"
                      /> -->
                    </div>
                  </template>
                </AccountsList>

              </template>
            </div>
            <div class="app-view-grid__col-26 tw-px-4">
              <template v-if="loadingStats">
                <p class="tw-py-10 opacity-54 tw-text-center">
                  Loading program users stats...
                </p>
              </template>

              <template v-else>
                <BaseCard class="tw-p-4 tw-mb-4" :style="`background-color: ${companyProgram.color2 || 'white'}`">
                  <p class="">
                    <span class="tw-font-bold tw-text-2xl">{{stats.unansweredRequests}}</span> Requests unanswered
                  </p>
                </BaseCard>
                <BaseCard class="tw-p-4 tw-mb-4" :style="`background-color: ${companyProgram.color2 || 'white'}`">
                  <p class="">
                    <span class="tw-font-bold tw-text-2xl">{{stats.acceptedRequests}}</span> Requests accepted
                  </p>
                </BaseCard>
                <BaseCard class="tw-p-4 tw-mb-4" :style="`background-color: ${companyProgram.color2 || 'white'}`">
                  <p class="">
                    <span class="tw-font-bold tw-text-2xl">{{stats.declinedRequests}}</span> Requests declined
                  </p>
                </BaseCard>
              </template>
            </div>
          </div>

        </transition>
      </div>

    </transition>

  </AppView>
</template>

<script>
import xlsx from 'json-as-xlsx';

import UserPhoto from '@/components/UserPhoto.vue';
import ContentLoadingFullWidth from '@/components/ContentLoadingFullWidth.vue';

import AccountsList from '@/views/_partials/AccountsList.vue';
import EditCompanyProgramUsers from '@/views/Companies/Company/_partials/EditCompanyProgramUsers.vue';

import companyMixin from '@/mixins/company';
import companyProgramMixin from '@/mixins/companyProgram';

export default {
  name: 'CompanyProgramUsers',
  components: {
    UserPhoto,
    ContentLoadingFullWidth,
    AccountsList,
    EditCompanyProgramUsers,
  },
  mixins: [companyMixin, companyProgramMixin],
  props: ['id', 'programId'],
  data() {
    return {
      loadingStats: true,
      errorProgramUsers: undefined,
      loadingProgramUsers: true,
      stats: {},
      programUsers: [],
      isActivatingUser: false,
      disabledReportBtn: false,
      reportBtnText: 'Export List',
    };
  },
  methods: {
    async getRequestsStats() {
      const formData = {
        progid: this.activeCompanyProgram.id,
      };

      this.loadingStats = true;

      this.stats = await this.$store.dispatch('getRequestsStats', formData);

      this.loadingStats = false;
    },
    async getProgramUsers() {
      this.loadingProgramUsers = true;
      this.errorProgramUsers = undefined;

      const users = await this.$store.dispatch('getProgramUsers', { progid: this.activeCompanyProgram.id });

      if (!users) {
        // toast error
        this.errorProgramUsers = 'Error fetching program users';
      } else {
        this.programUsers = users;
      }

      this.loadingProgramUsers = false;
    },
    async removeUserFromProgram(user) {
      const handleRemoveUserFromProgram = async () => {
        this.$toasted.info('Working...', { duration: 5000 });

        const formData = {
          progid: this.activeCompanyProgram.id,
          userid: user.id,
          reason: '[admin]',
          adminid: this.$store.state.User.id,
        };

        const result = await this.$store.dispatch('removeUserFromProgram', formData);

        await this.$nextTick();

        if (!result) {
          this.$toasted.global.appError();
        } else {
          this.$toasted.success('Success!', { duration: 1000 });
          await this.getProgramUsers();
        }
      };

      // open dialog modal
      this.$store.commit('openModal', [
        true,
        'dialog',
        false,
        handleRemoveUserFromProgram,
        `Are you sure you want to remove ${user.name} from program?`,
      ]);
    },
    async activateUserToProgram(user) {
      this.isActivatingUser = true;

      const result = await this.$store.dispatch('activateUserToProgram', {
        progid: this.activeCompanyProgram.id,
        userid: user.id,
      });

      if (!result) {
        this.$toasted.global.appError({
          errorMessage: 'Error activating user to program',
        });
      } else {
        this.$toasted.success('User activated!', { duration: 1000 });

        const userIndex = this.programUsers.findIndex((u) => u.id === user.id);
        this.programUsers[userIndex].programStatus = 1;
      }

      this.isActivatingUser = false;
    },
    async deactivateUserToProgram(user) {
      this.isActivatingUser = true;

      const result = await this.$store.dispatch('deactivateUserToProgram', {
        progid: this.activeCompanyProgram.id,
        userid: user.id,
      });

      if (!result) {
        this.$toasted.global.appError({
          errorMessage: 'Error deactivating user to program',
        });
      } else {
        this.$toasted.success('User deactivated!', { duration: 1000 });

        const userIndex = this.programUsers.findIndex((u) => u.id === user.id);
        this.programUsers[userIndex].programStatus = 0;
      }

      this.isActivatingUser = false;
    },
    /*
        Generate Report
    */
    async generateReport() {
      this.disabledReportBtn = true;
      this.reportBtnText = 'Exporting...';

      this.$toasted.info('Exporting program users information', {
        duration: 4000,
        position: 'top-right',
      });

      const users = new Array(...this.programUsers);
      const sheetName = 'all program users';
      //

      const accType = (typeId) => {
        switch (Number(typeId)) {
          case 3:
            return 'mentor';
          case 4:
            return 'mentee';
          default:
            return '';
        }
      };

      const data = [
        {
          sheet: `${sheetName}`,
          columns: [
            { label: 'User', value: (row) => `${row.name} ${row.last_name}` },
            { label: 'Type', value: (row) => accType(row.type) },
            { label: 'Email', value: 'email' },
            { label: 'Gender', value: (row) => (row.gender === '1' ? 'male' : 'female') },
            { label: 'Staff no.', value: 'staff' },
            { label: 'Region', value: (row) => row?.region?.region || '' },
            { label: 'Date Signed Up', value: 'dateCreated' },
            { label: 'Date Last Logged in', value: 'dateLastLogin' },
          ],
          content: users,
        },
      ];

      const settings = {
        fileName: `Program Users in ${this.activeCompanyProgram.name} program ${new Date().toLocaleDateString()}`,
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      };

      // eslint-disable-next-line no-unused-vars
      xlsx(data, settings, (e) => {
        // console.log('complete!', e);
      });

      this.disabledReportBtn = false;
      this.reportBtnText = 'Export List';
    },
    async programUsersUpdated() {
      this.closeModal();

      this.getProgramUsers();
      this.getRequestsStats();
    },
    async promptAddUsersToProgram() {
      this.$store.commit('openModal', [true, 'full-screen']);
    },
  },
  async created() {
    // get company
    await this.getCompany();
    await this.$nextTick();

    // assert user company permissions
    if (!this.hasPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.getCompanyProgram();
    await this.$nextTick();

    if (!this.hasProgramPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.$nextTick();

    this.loadingCompany = false;

    this.getRequestsStats();
    this.getProgramUsers();

    return true;
  },
};
</script>

<style>

</style>
